module.exports = __webpack_public_path__ + "static/media/Banner02.d173eae6.png";